import { useQuery } from "@tanstack/react-query";
import { fetchProjectsApi } from "@/API/fetchProjectsApi";
import { useLoadingContext } from "@/hooks/contextHooks/useLoadingContext";

export const useFetchProjects = () => {
  const { startLoading, stopLoading } = useLoadingContext();

  const query = useQuery({
    queryKey: ["projects"],
    queryFn: async () => {
      startLoading();

      try {
        return await fetchProjectsApi();
      } finally {
        console.log("✅ Request completed.");
        stopLoading();
      }
    },
    retry: 1,
  });

  if (query.isFetching) {
    console.log("❌ Request overridden for projects.");
  }

  return query;
};
